import { domain } from 'modules/data';

export interface ApprovalWorkflowsProps {
    companyId: string;
    isLoading: boolean;
    disabled: boolean;
    workflows?: domain.WorkflowsParticipant[];
}

export enum ApprovalWorkflowsColumnsIds {
    Warning = 'warning',
    WorkflowName = 'name',
    Step = 'step',
    Role = 'role',
    Replacement = 'replacement',
}
